module.exports = __webpack_public_path__ + "media/assets/services_manager/gray-left-arrow-f709ccdf62d196ddbc70c3bdf9014c5b56af9e10507a4a3ba68b721dae39daef.svg";